
import { VTab } from "vuetify/lib";

export default VTab.extend({});
